import { useEffect, useState, useRef } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { fetchContent } from '@services/wpApi'
import checkSubs from '@services/checkSubs'
import { useStore } from '@context/store'
import Subscribe from '@components/Subscribe'
import { fetchKeyword } from '../../services/wpApi'
import Content from './components/Content'


const Keyword = () => {
  const [getContent, setGetContent] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);
  const unmounted = useRef(false);
  const { slug } = useParams();

  const {
    user: {
      msisdn: num
    },
    serviceName: service
  } = useStore();

  const  { data: keyword } = useQuery(['keyword', slug], () => fetchKeyword(slug)); 
  const { status, fetchStatus, data: content } = useQuery(
    [service, slug], 
    () => fetchContent(slug),
    {
      enabled: getContent
    }
  );

  useEffect(() => {
    if(keyword) {
      if(!unmounted.current && Object.keys(keyword).length > 0) {
        const checkSubscription = async () => {
          const response = await checkSubs(keyword.service_id, num);
  
          if(response.status) {
            setGetContent(true);
          } else {
            setShowSubscription(true);
          }
        }
  
        checkSubscription()
        .catch((err) => {
          console.log(err)
        })
  
        unmounted.current = true;
      }
    }
  }, [keyword]); // eslint-disable-line

  if(showSubscription) return <Subscribe 
    {...{
      num,
      service,
      keyword,
      onConfirmed: () => {
        setGetContent(true);
        setShowSubscription(false);
      }
    }}
  />

  return (
    <div>
      {status === 'loading' && fetchStatus === 'fetching' ? 
        <>loading...</> 
      :
        content && content.map((post) => <div key={post.id} className='px-4'>
          <Content {...post} />
        </div>)
      }
    </div>
  )
}

export default Keyword